/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';
import cx from 'classnames';
import PT from 'prop-types';

import style from './Table.scss';

// This assumes it's in a page with the `grid` and `exam` classes set.
// TODO(dc): once all grids are converted, remove those classes and
// fix all the styles
class Table extends Component {
  render() {
    const { children, className, ...restProps } = this.props;
    return (
      <div className={cx(style.outerContainer, className)} {...restProps}>
        <div className={style.innerContainer}>
          <table className={style.Table}>{children}</table>
        </div>
      </div>
    );
  }
}

const Row = ({ children, ...restProps }) => <tr {...restProps}>{children}</tr>;

Table.Row = Row;

const Cell = ({ children, className, spacer, ...restProps }) => (
  <td
    className={cx([style.Cell, className, spacer ? style.spacer : null])}
    {...restProps}
  >
    {children}
  </td>
);
Cell.propTypes = {
  className: PT.string,
};
Table.Cell = Cell;

//
// HEADINGS
//

const Head = ({ children, className, isSticky, ...restProps }) => (
  <thead className={cx([style.Head, className])} {...restProps}>
    {children}
  </thead>
);
Head.propTypes = {
  className: PT.string,
};
Table.Head = Head;

const RowHeader = ({ children, isSticky, className, ...restProps }) => (
  <th
    className={cx([
      style.RowHeader,
      isSticky ? style.horizSticky : null,
      className,
    ])}
    {...restProps}
  >
    {children}
  </th>
);
RowHeader.propTypes = {
  isSticky: PT.bool,
  className: PT.string,
};
Table.RowHeader = RowHeader;

const ColHeader = ({
  children,
  isSticky,
  isHorizSticky, // useful for the top-left corner of table
  className,
  spacer,
  ...restProps
}) => (
  <th
    className={cx([
      style.ColHeader,
      isSticky ? style.vertSticky : null,
      isHorizSticky ? style.horizSticky : null,
      spacer ? style.spacer : null,
      className,
    ])}
    {...restProps}
  >
    {children}
  </th>
);
ColHeader.propTypes = {
  isSticky: PT.bool,
  isHorizSticky: PT.bool,
  className: PT.string,
  colSpan: PT.number,
};
Table.ColHeader = ColHeader;

//
// BODY
//

const Body = ({ children, ...restProps }) => (
  <tbody {...restProps}>{children}</tbody>
);
Table.Body = Body;

export default Table;
